import SlideApi from '@/api/slide'

const getAttributeChangesTopic = ({ presentationId }) => {
  return `presentation-${presentationId}-slide-attributes/#`
}
// One callback per topic, reused by every subscribe, so a release by callback balances whichever editor subscribed.
const attributeChangesCallbacks = {}
const slideAttributesAction = {
  subscribeAttributeChanges: async (
    { commit, dispatch },
    { presentationId },
  ) => {
    if (!presentationId) return
    const key = getAttributeChangesTopic({ presentationId })
    attributeChangesCallbacks[key] = attributeChangesCallbacks[key] || ((topic, message) => {
      // For reference: the topic is form in general-api
      // services-layer/slide-service
      const regex = /slide-(\d+)-(.+)$/
      const match = topic.match(regex)
      if (!match) return
      const [, slideId, attributeKey] = match
      const attributeValue = JSON.parse(message)
      const attributeUpdated = { [attributeKey]: attributeValue }
      commit('updateAttributes', { presentationId, slideId, attributes: attributeUpdated })
    })
    dispatch('kvSync/subscribeKeyAction', { key, callback: attributeChangesCallbacks[key] }, { root: true })
  },
  unsubscribeAttributeChanges: ({ dispatch }, { presentationId }) => {
    const key = getAttributeChangesTopic({ presentationId })
    if (!attributeChangesCallbacks[key]) return
    dispatch('kvSync/unsubscribeKeyAction', { key, callback: attributeChangesCallbacks[key] }, { root: true })
  },
  bulkUpdateAttributes: async (
    { commit },
    { presentationId, slides },
  ) => {
    if (!presentationId || !slides?.length) return
    await SlideApi.bulkUpsertSlideAttributes({ presentationId, slides })
    slides.forEach(({ id, slideAttributes }) => {
      commit('updateAttributes', {
        presentationId,
        slideId: id,
        attributes: slideAttributes,
      })
    })
  },
  getByKeys: async (
    { commit, dispatch },
    { presentationId, attributeKeys },
  ) => {
    if (!presentationId || !attributeKeys?.length) return
    const resp = await dispatch(
      'getSlideAttributesByPresentationId',
      { presentationId, attributeKeys: attributeKeys.join(',') },
      { root: true },
    )
    if (!Array.isArray(resp)) return
    const requestedKeys = new Set(attributeKeys)
    resp.forEach((row) => {
      if (!row.type || !row.attributes || !requestedKeys.has(row.type)) return
      commit('updateAttributes', {
        presentationId,
        slideId: row.slideId,
        attributes: { [row.type]: row.attributes },
      })
    })
  },
}

export default slideAttributesAction
